import React, { createContext, useContext } from 'react';
import PropTypes from 'prop-types';

import { useAccountSettingMutation } from 'utils/api/mutations';

const accountSettingsContext = createContext({});

export const AccountSettingsContextProvider = ({ children }) => {
  const changePasswordMutation =
    useAccountSettingMutation.useChangePasswordMutation();
  const userProfileMutation =
    useAccountSettingMutation.useUserProfileMutation();
  const deleteAccountMutation =
    useAccountSettingMutation.useDeleteAccountMutation();
  const requestEmailChangeMutation =
    useAccountSettingMutation.useRequestEmailChangeMutation();
  const confirmEmailChangeMutation =
    useAccountSettingMutation.useConfirmEmailChangeMutation();

  return (
    <accountSettingsContext.Provider
      value={{
        changePasswordMutation,
        userProfileMutation,
        deleteAccountMutation,
        requestEmailChangeMutation,
        confirmEmailChangeMutation,
      }}
    >
      {children}
    </accountSettingsContext.Provider>
  );
};

AccountSettingsContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAccountSettingsContext = () => {
  const {
    changePasswordMutation,
    userProfileMutation,
    deleteAccountMutation,
    requestEmailChangeMutation,
    confirmEmailChangeMutation,
  } = useContext(accountSettingsContext);

  return {
    changePasswordMutation,
    userProfileMutation,
    deleteAccountMutation,
    requestEmailChangeMutation,
    confirmEmailChangeMutation,
  };
};
